import { render, staticRenderFns } from "./ReportCultureCard.vue?vue&type=template&id=36b5ecdc&scoped=true&"
import script from "./ReportCultureCard.vue?vue&type=script&lang=js&"
export * from "./ReportCultureCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportCultureCard.vue?vue&type=style&index=0&id=36b5ecdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5ecdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VFadeTransition,VProgressCircular,VRow})
